module.exports = __webpack_public_path__ + "static/transports-in-japan-okinawa-map-b2700576b419431a1c6cb17cb17b3c02.jpg";